import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { PropertyFaq } from '@shared-ui/lodging-property-details';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

const PropertyFaqWrapper: React.FC<SharedUiWrapperProps> = React.memo(({ inputs }) => {
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();

  const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);

  return (
    <ErrorBoundary label="hotel.property.faq">
      <SimpleLazyLoadWrapper>
        <UitkSpacing margin={{ blockstart: 'six' }}>
          <div>
            <PropertyFaq inputs={{ ...inputs, searchCriteria: propertySearchCriteria }} />
          </div>
        </UitkSpacing>
      </SimpleLazyLoadWrapper>
    </ErrorBoundary>
  );
});

export const SharedUiPropertyFaqWrapper = withSharedUiPropertyDetails(PropertyFaqWrapper);
PropertyFaqWrapper.displayName = 'SharedUiPropertyFaqWrapper';
